// import { getLoggerTokenAsync } from './getLoggerToken';
import { logger } from './loggerInstance';
import { BETTERSTACK_API_KEY } from '@constants';

export const initLogger =  (): void => {
  // const { data, success } = await getLoggerTokenAsync();
  // if (success && data != null) {
  logger.init(BETTERSTACK_API_KEY);
  // }
};
